// =====================================================
// 📁 POSCreditNoteOverlay.tsx
// =====================================================

const POSCreditNoteOverlay = () => {
  return (
    <div
      className="
        absolute
        inset-0
        z-10

        flex
        items-center
        justify-center

        bg-slate-900/35

        backdrop-blur-[2px]
      "
    >
      <div
        className="
          rotate-[-10deg]

          rounded-2xl
          border-2
          border-[#DC3545]

          bg-white/95

          px-5
          py-2.5

          shadow-xl

          dark:bg-boxdark/95
        "
      >
        <span
          className="
            block

            text-sm
            font-extrabold
            uppercase
            tracking-[0.2em]

            text-[#DC3545]
          "
        >
          Acreditado
        </span>
      </div>
    </div>
  );
};

export default POSCreditNoteOverlay;